import { ProductVariantOption } from './ProductVariant'

export enum PRODUCT_TAG_TYPE {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

interface IProductTag {
  value: string
  options: ProductVariantOption[]
  tagType?: PRODUCT_TAG_TYPE
  showOnProductPage?: boolean
  backgroundColor?: string
  textColor?: string
  showOnStockAvailability?: boolean
  vendor_type?: string
}

export default class ProductTag implements IProductTag {
  value: string
  options: ProductVariantOption[]
  tagType?: PRODUCT_TAG_TYPE
  showOnProductPage?: boolean
  showOnStockAvailability?: boolean
  vendor_type?: string

  constructor({ value, options, tagType, showOnProductPage, showOnStockAvailability, vendor_type }: IProductTag) {
    this.value = value
    this.options = options
    this.tagType = tagType
    this.showOnProductPage = showOnProductPage
    this.tagType = tagType
    this.showOnStockAvailability = showOnStockAvailability
    this.vendor_type = vendor_type
    return {
      ...this,
    }
  }
}
